import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'CREDIT_NOTE_SHOW_ERROR':
      return action.error;

    case 'CREDIT_NOTE_SHOW_RESET':
      return null;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'CREDIT_NOTE_SHOW_LOADING':
      return action.loading;

    case 'CREDIT_NOTE_SHOW_RESET':
      return false;

    default:
      return state;
  }
}

export function retrieved(state = null, action) {
  switch (action.type) {
    case 'CREDIT_NOTE_SHOW_RETRIEVED_SUCCESS':
      return action.retrieved;

    case 'CREDIT_NOTE_SHOW_RESET':
      return null;

    default:
      return state;
  }
}

export default combineReducers({
  error, loading, retrieved,
});
